window.HPLab = window.HPLab || {};
(function () {
  "use strict";
  function findByKey(list, key) {
    for (var i = 0; i < list.length; i++) { if (list[i].key === key) return list[i]; }
    return null;
  }
  HPLab.DiagnosisEngine = {
    applyAnswer: function (question, optionIndex) {
      var option = question.options[optionIndex];
      if (!option || !option.scores) return;
      Object.keys(option.scores).forEach(function (hypothesisKey) {
        HPLab.State.addScore(hypothesisKey, option.scores[hypothesisKey]);
      });
    },
    compute: function (diagnosisData) {
      var scores = HPLab.State.get().scores;
      var keys = Object.keys(scores);
      if (keys.length === 0) return null;
      keys.sort(function (a, b) { return scores[b] - scores[a]; });
      var positiveTotal = keys.reduce(function (sum, k) { return sum + Math.max(scores[k], 0); }, 0) || 1;
      var topKey = keys[0];
      var topMeta = findByKey(diagnosisData, topKey) || { title: topKey, explanation: "" };
      var confidence = Math.min(97, Math.max(55, Math.round((Math.max(scores[topKey], 0) / positiveTotal) * 100)));
      var secondary = keys.slice(1).map(function (k) {
        var meta = findByKey(diagnosisData, k) || { title: k };
        var pct = Math.round((Math.max(scores[k], 0) / positiveTotal) * 100);
        return { title: meta.title, percent: pct };
      }).filter(function (c) { return c.percent > 0; }).slice(0, 3);
      return { key: topKey, title: topMeta.title, explanation: topMeta.explanation, confidence: confidence, secondary: secondary };
    }
  };
})();
